export default __webpack_public_path__ + "static/bg-stars-52c535b237cac564ae1ab9898128e05c.png";